import moment from 'moment'

function enumerateDaysBetweenDates (startDate, endDate, inclusive) {
  const dates = []

  var currDate = moment(startDate).startOf('day')
  var lastDate = moment(endDate).startOf('day')
  if (inclusive) {
    dates.push(currDate.clone().format('YYYY-MM-DD'))
  }
  while (currDate.add(1, 'days').diff(lastDate) < 0) {
    dates.push(currDate.clone().format('YYYY-MM-DD'))
  }
  if (inclusive) {
    dates.push(currDate.clone().format('YYYY-MM-DD'))
  }
  return dates
}

export {
  enumerateDaysBetweenDates,
}
